import React from 'react';
import { ShareIcon } from 'lucide-react';
import { IconButton } from './IconButton';

type ShareButtonProps = {
  setIsOpen: () => void;
};

export const ShareButton = ({ setIsOpen }: ShareButtonProps) => {
  return <IconButton icon={<ShareIcon />} label="Share" onClick={setIsOpen} />;
};
